import { useEffect, useState } from "react";

export default function PedidosView() {
  const [pedidos, setPedidos] = useState([]);
  const [pedidoExpandidoId, setPedidoExpandidoId] = useState(null);

  useEffect(() => {
    const cargarPedidos = async () => {
      try {
        const res = await fetch("http://localhost:5000/api/pedidos/admin/pedidos");
        const data = await res.json();

        // 🔍 Detecta si la respuesta trae { pedidos: [] }
        const lista = Array.isArray(data) ? data : data.pedidos || [];

        // 🎯 Filtrar pedidos finalizados (solo los que realmente están finalizados)
        const finalizados = lista.filter(p => {
          const estado = (p.estado || "").toLowerCase();
          return (
            estado === "completado" ||      // Delivery lo recibe
            estado === "cerrado" ||         // Retiro cerrado por admin
            estado === "cerrado_por_cliente"// Cliente lo cerró manualmente
          );
        });

        setPedidos(finalizados);
      } catch (err) {
        console.error("❌ Error cargando pedidos:", err);
      }
    };

    cargarPedidos();
  }, []);

  const toggleDetalles = (id) => {
    setPedidoExpandidoId(prev => (prev === id ? null : id));
  };

  return (
    <div>
      <h2 className="text-white mb-3">
        <i className="fas fa-check text-white me-2"></i>
        Pedidos finalizados
      </h2>

      <ul className="list-group">
        {pedidos.length > 0 ? (
          pedidos.map((p) => (
            <li
              key={p.id}
              className="list-group-item bg-dark"
              style={{ borderRadius: "10px", marginBottom: "10px" }}
            >
              {/* 🔹 Encabezado del pedido */}
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <i className="bi bi-person-circle fs-4 me-2" style={{ color: 'white' }}></i>
                  <strong className="text-white ms-2">{p.cliente_nombre || p.cliente_id}</strong>
                  <span className="text-white ms-2">({p.estado})</span>
                </div>

                <button
                  className="btn btn-sm btn-outline-danger"
                  onClick={() => toggleDetalles(p.id)}
                >
                  {pedidoExpandidoId === p.id ? "Ocultar detalles" : "Ver detalles"}
                </button>
              </div>

              {/* 🔽 Detalles colapsables */}
              {pedidoExpandidoId === p.id && (
                <div className="card bg-dark text-white mt-3 border border-danger">
                  <div className="card-body">
                    <h5>Pedido ID: {p.id}</h5>
                    <p><strong>Cliente:</strong> {p.cliente_nombre || p.cliente_id}</p>
                    <p><strong>Estado:</strong> {p.estado}</p>
                    <p><strong>Precio final:</strong> {p.precio_final}</p>
                    <p><strong>Modo de entrega:</strong> {p.modo_entrega}</p>

                    <h6 className="mt-3">Productos:</h6>
                    <ul>
                      {Array.isArray(p.productos)
                        ? p.productos.map((prod, i) => (
                            <li key={i}>
                              {prod.cantidad} × {prod.producto}
                              {prod.corte ? ` (${prod.corte})` : ""}
                            </li>
                          ))
                        : <li className="text-muted">Sin productos</li>}
                    </ul>
                  </div>
                </div>
              )}
            </li>
          ))
        ) : (
          <li className="list-group-item text-muted">
            No hay pedidos finalizados
          </li>
        )}
      </ul>
    </div>
  );
}
